import { ThemeManager } from '../../react/themes/theme-manager';
import { CerbosFeature } from '../../services/cerbos/features';
import { CerbosView } from '../../services/cerbos/views';
import { CerbosPermissionStatus, PermissionStore } from '../../stores/permission-store';
import { FeatureFlagsManager } from '../core/feature-flags-manager';
import { licensePermissionChecks } from './license';

type AccessVerification = (() => boolean) | boolean;

const hasAccessToView = (
  routePath: string,
  cerbosView?: CerbosView,
  additionalVerifications: AccessVerification[] = [],
) => {
  const cerbosAccessCheck = PermissionStore.instance.checkAccessToView(cerbosView);
  if (
    FeatureFlagsManager.instance.isEnabled('SK-4477-access-management') &&
    cerbosAccessCheck !== CerbosPermissionStatus.NOT_DEFINED
  ) {
    return cerbosAccessCheck === CerbosPermissionStatus.ACCEPT;
  }

  const anyVerificationCheckFailed = additionalVerifications.some((verification) =>
    typeof verification === 'function' ? !verification() : !verification,
  );

  return (
    ThemeManager.instance.hasAccessToRoute(routePath) &&
    licensePermissionChecks.hasAccessToViewByUserLicenses(routePath) &&
    !anyVerificationCheckFailed
  );
};

const hasAccessToFeature = (
  cerbosFeature: CerbosFeature,
  additionalVerifications: AccessVerification[] = [],
) => {
  const cerbosAccessCheck = PermissionStore.instance.checkAccessToFeature(cerbosFeature);
  if (
    FeatureFlagsManager.instance.isEnabled('SK-4477-access-management') &&
    cerbosAccessCheck !== CerbosPermissionStatus.NOT_DEFINED
  ) {
    return cerbosAccessCheck === CerbosPermissionStatus.ACCEPT;
  }

  const anyVerificationCheckFailed = (
    Array.isArray(additionalVerifications) ? additionalVerifications : [additionalVerifications]
  ).some((verification) => (typeof verification === 'function' ? !verification() : !verification));

  return (
    ThemeManager.instance.hasAccessToFeature(cerbosFeature) &&
    licensePermissionChecks.hasAccessToFeatureByUserLicenses(cerbosFeature) &&
    !anyVerificationCheckFailed
  );
};

export const permissionChecks = { hasAccessToView, hasAccessToFeature };
